
export default {
  name: 'BlocksArticleHero',
  props: {
    page: { type: Object, required: true },
    // When true, renders a full-width image below the text instead of side-by-side
    fullWidthImage: { type: Boolean, default: true },
  },
  computed: {
    author() {
      const node = this.page?.author?.node
      if (!node) return null
      return {
        ...node,
        avatar: node.avatar ? { url: decodeURIComponent(node.avatar.url) } : null,
      }
    },
    // Returns the full first category node (name + slug) rather than just the name
    category() {
      return this.page?.categories?.nodes?.[0] || null
    },
    // Derives the category URL from the first path segment of the current route
    categoryPath() {
      const segment = this.$route.path.split('/').filter(Boolean)[0]
      return segment ? `/${segment}/` : '/'
    },
    readTime() {
      if (!this.page?.content) return null
      const words = this.page.content.replace(/<[^>]+>/g, '').split(/\s+/).length
      return Math.max(1, Math.ceil(words / 200))
    },
    formattedDate() {
      if (!this.page?.modified) return null
      return new Date(this.page.modified).toLocaleDateString('en-GB', {
        day: 'numeric', month: 'long', year: 'numeric',
      })
    },
  },
}
